const actions = {
    READ_CURRENCIES_REQUEST: 'READ_CURRENCIES_REQUEST',
    READ_CURRENCIES_SUCCESS: 'READ_CURRENCIES_SUCCESS',
    READ_CURRENCIES_ERROR: 'READ_CURRENCIES_ERROR',

    ACTIVATE_CURRENCY_REQUEST: 'ACTIVATE_CURRENCY_REQUEST',
    ACTIVATE_CURRENCY_SUCCESS: 'ACTIVATE_CURRENCY_SUCESS',
    ACTIVATE_CURRENCY_ERROR: 'ACTIVATE_CURRENCY_ERROR',

    READ_CURRENCY_RATE_REQUEST: 'READ_CURRENCY_RATE_REQUEST',
    READ_CURRENCY_RATE_SUCCESS: 'READ_CURRENCY_RATE_SUCCESS',
    READ_CURRENCY_RATE_ERROR: 'READ_CURRENCY_RATE_ERROR',
    RESET_CURRENCY: 'RESET_CURRENCY',
    ARCHIVE_CURRENCY_REQUEST: 'ARCHIVE_CURRENCY_REQUEST',
    ARCHIVE_CURRENCY_SUCCESS: 'ARCHIVE_CURRENCY_SUCCESS',
    ARCHIVE_CURRENCY_ERROR: 'ARCHIVE_CURRENCY_ERROR',

    READ_CURRENCY_RATES_REQUEST: 'READ_CURRENCY_RATES_REQUEST',
    READ_CURRENCY_RATES_SUCCESS: 'READ_CURRENCY_RATES_SUCCESS',
    READ_CURRENCY_RATES_ERROR: 'READ_CURRENCY_RATES_ERROR',

    CREATE_CURRENCY_RATE_REQUEST: 'CREATE_CURRENCY_RATE_REQUEST',
    CREATE_CURRENCY_RATE_SUCCESS: 'CREATE_CURRENCY_RATE_SUCCESS',
    CREATE_CURRENCY_RATE_ERROR: 'CREATE_CURRENCY_RATE_ERROR',

    UPDATE_CURRENCY_RATE_REQUEST: 'UPDATE_CURRENCY_RATE_REQUEST',
    UPDATE_CURRENCY_RATE_SUCCESS: 'UPDATE_CURRENCY_RATE_SUCCESS',
    UPDATE_CURRENCY_RATE_ERROR: 'UPDATE_CURRENCY_RATE_ERROR',

    DELETE_CURRENCY_RATE_REQUEST: 'DELETE_CURRENCY_RATE_REQUEST',
    DELETE_CURRENCY_RATE_SUCCESS: 'DELETE_CURRENCY_RATE_SUCCESS',
    DELETE_CURRENCY_RATE_ERROR: 'DELETE_CURRENCY_RATE_ERROR',

    SET_CURRENCY_RATE: 'CURRENCY_SET_CURRENCY_RATE',

    readCurrencies: payload => ({
        type: actions.READ_CURRENCIES_REQUEST,
        payload,
    }),
    activateCurrency: code => ({
        type: actions.ACTIVATE_CURRENCY_REQUEST,
        code,
    }),
    readCurrencyRate: request => ({
        type: actions.READ_CURRENCY_RATE_REQUEST,
        request,
    }),
    resetCurrency: () => ({
        type: actions.RESET_CURRENCY,
    }),
    archiveCurrency: (code, payload) => ({
        type: actions.ARCHIVE_CURRENCY_REQUEST,
        code,
        payload,
    }),

    // exchange rates
    readCurrencyRates: (currencyCode, queryStringObject) => ({
        type: actions.READ_CURRENCY_RATES_REQUEST,
        currencyCode,
        queryStringObject,
    }),
    createCurrencyRate: (currencyCode, request) => ({
        type: actions.CREATE_CURRENCY_RATE_REQUEST,
        currencyCode,
        request, // {rate: float, date_from: string, date_to: string}
    }),
    updateCurrencyRate: (currencyCode, id, request) => ({
        type: actions.UPDATE_CURRENCY_RATE_REQUEST,
        currencyCode,
        id,
        request, // {rate: float, date_from: string, date_to: string}
    }),
    deleteCurrencyRate: (currencyCode, id) => ({
        type: actions.DELETE_CURRENCY_RATE_REQUEST,
        currencyCode,
        id, // exchange rate's id
    }),
    setCurrencyRateInfo: (currencyRateInfo, isEditMode = false) => ({
        type: actions.SET_CURRENCY_RATE,
        currencyRateInfo,
        isEditMode,
    }),
};
export default actions;
